import { render, staticRenderFns } from "./springFRewardRecord.vue?vue&type=template&id=66d32290&scoped=true"
import script from "./springFRewardRecord.vue?vue&type=script&lang=ts"
export * from "./springFRewardRecord.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d32290",
  null
  
)

export default component.exports